
<div class="compactMarunageForm">
  <h2 class="compactMarunageForm__title">{{ title }}</h2>
  <div class="ui big form clickable" style="position: relative;">
    <div class="ui warning message" v-if="form.hasErrors()">
      <ul class="list">
        <li v-if="form.hasError('area')">エリアを選択してください</li>
        <li v-if="form.hasError('people')">人数を選択してください</li>
        <li v-if="form.hasError('price')">一人あたりの予算を選択してください</li>
        <li v-if="form.hasError('event_date')">希望日を選択してください</li>
        <li v-if="form.hasError('event_time')">希望時間を選択してください</li>
        <li v-if="form.hasError('tel')">電話番号を半角数字のみ10桁または11桁で入力してください</li>
        <li v-if="form.hasError('email')">メールアドレスを正しく入力してください</li>
      </ul>
    </div>
    <div class="ui form">
      <div v-if="!form.model.shop_id" class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('area')}">
          <dropdown v-model="form.model.area" @change="onAreaChange()" :placeholder="'エリア(必須)'">
            <option v-for="each in consts.MARUNAGE_SHOP_AREA" :key="each.label" :value="each.value" :disabled="each.value === ''">
              {{ each.label }}
            </option>
          </dropdown>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('area_detail')}">
          <dropdown ref="areaDetail" v-model="form.model.area_detail" :placeholder="'エリア詳細'">
            <option value="">エリア詳細</option>
          </dropdown>
        </div>
      </div>
      <div class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('people')}">
          <dropdown v-model="form.model.people" :options="consts.MARUNAGE_PEOPLE" :placeholder="'人数(必須)'"></dropdown>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('price')}">
          <dropdown v-model="form.model.price" :options="consts.MARUNAGE_PRICE" :placeholder="'予算(必須)'"></dropdown>
        </div>
      </div>
      <div class="two fields compactMarunageForm__row">
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('event_date')}">
          <datepick v-model="form.model.event_date" :placeholder="'希望日(必須)'" :from="3"></datepick>
        </div>
        <div class="field compactMarunageForm__item" :class="{'error': form.hasError('event_time')}">
          <dropdown v-model="form.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間(必須)'"></dropdown>
        </div>
      </div>
      <div class="caption compactMarunageForm__caption">
        日程が確定していない場合は仮の日時をご指定いただき、希望条件欄に大体の開催時期をご記載ください
      </div>
      <div v-if="!userId" class="field compactMarunageForm__row" :class="{'error': form.hasError('email')}">
        <input type="text" v-model="form.model.email" :placeholder="'ご連絡先メールアドレス(必須)'" />
      </div>
      <div v-if="!hasTel" class="field compactMarunageForm__row" :class="{'error': form.hasError('tel')}">
        <input type="text" v-model="form.model.tel" :placeholder="'ご連絡先電話番号(必須)'" />
      </div>
      <div class="field compactMarunageForm__row" :class="{'error': form.hasError('note')}">
        <textarea rows="2" v-model="form.model.note" placeholder="希望条件があればご記入ください。"></textarea>
      </div>
      <app-message :msg="form.appMessage"></app-message>
      <div class="field">
        <button @click="marunage" class="ui fluid orange button large compactMarunageForm__btn" :class="{'disabled loading': form.waiting}">{{ actionLabel }}</button>
      </div>
    </div>
    <div id="detailed-marunage-form-dialog" class="ui modal">
      <i class="close icon"></i>
      <div class="scrolling content">
        <detailed-marunage-form :form-name-prefix="formNamePrefix" action-label="送信する"></detailed-marunage-form>
      </div>
    </div>
    <a @click.prevent="openDialog" class="compactMarunageForm__clickArea"></a>
  </div>
</div>
